module.exports = __webpack_public_path__ + "a413c3a4ad8eb92a8bc08c60122d0226.svg";